import { showToast } from '@/lib/useToastStore';
import { trackGuestWritePromptShown } from '@/lib/analytics/posthog';
import { router } from 'expo-router';

const GUEST_WRITE_TOAST_MESSAGE = 'Sign in to RSVP, save, comment, and follow.';

type GuestWritePromptOptions = {
  message?: string;
  next?: string;
  onSignIn?: () => void;
};

export function showGuestWritePrompt(
  action: string = 'unknown',
  options: GuestWritePromptOptions = {}
) {
  trackGuestWritePromptShown(action);
  showToast({
    actionLabel: 'Sign in',
    durationMs: 3000,
    message: options.message ?? GUEST_WRITE_TOAST_MESSAGE,
    onAction: () => {
      options.onSignIn?.();
      router.push({
        pathname: '/sign-in',
        params: options.next ? { next: options.next } : undefined,
      });
    },
  });
}
